"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _HiFormControl = _interopRequireDefault(require("../HiForm/HiFormControl"));
var _HiSelect = _interopRequireDefault(require("./HiSelect"));
var _classnames = _interopRequireDefault(require("classnames"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // @inheritedComponent HiSelect
var styles = exports.styles = {
  root: {
    maxWidth: 500
  }
};

/**
 * Champs input pour formulaire
 */
var HiSelectField = /*#__PURE__*/function (_React$PureComponent) {
  function HiSelectField() {
    (0, _classCallCheck2.default)(this, HiSelectField);
    return _callSuper(this, HiSelectField, arguments);
  }
  (0, _inherits2.default)(HiSelectField, _React$PureComponent);
  return (0, _createClass2.default)(HiSelectField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        required = _this$props.required,
        disabled = _this$props.disabled,
        error = _this$props.error,
        errorText = _this$props.errorText,
        helperText = _this$props.helperText,
        helperIcon = _this$props.helperIcon,
        id = _this$props.id,
        name = _this$props.name,
        value = _this$props.value,
        options = _this$props.options,
        type = _this$props.type,
        multiple = _this$props.multiple,
        iconAll = _this$props.iconAll,
        checkbox = _this$props.checkbox,
        searchable = _this$props.searchable,
        translations = _this$props.translations,
        className = _this$props.className,
        classes = _this$props.classes,
        HiInputLabelProps = _this$props.HiInputLabelProps,
        others = (0, _objectWithoutProperties2.default)(_this$props, ["label", "required", "disabled", "error", "errorText", "helperText", "helperIcon", "id", "name", "value", "options", "type", "multiple", "iconAll", "checkbox", "searchable", "translations", "className", "classes", "HiInputLabelProps"]);
      return /*#__PURE__*/_react.default.createElement(_HiFormControl.default, {
        id: id,
        label: label,
        required: required,
        disabled: disabled,
        error: error,
        errorText: errorText,
        helperText: helperText,
        helperIcon: helperIcon,
        className: (0, _classnames.default)(classes.root, className),
        InputLabelProps: HiInputLabelProps
      }, /*#__PURE__*/_react.default.createElement(_HiSelect.default, (0, _extends2.default)({
        id: id,
        name: name,
        value: value,
        options: options,
        type: type,
        multiple: multiple,
        iconAll: iconAll,
        checkbox: checkbox,
        searchable: searchable,
        translations: translations,
        disabled: disabled,
        error: error
      }, others)));
    }
  }]);
}(_react.default.PureComponent);
var _default = exports.default = (0, _withStyles.default)(styles)(HiSelectField);